import _ from 'lodash';
import { push } from "../../helpers/navigation/navigationService";
import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all, delay } from "redux-saga/effects";

import api from "../../Environment";
import {
  fetchUserDetailsSuccess,
  fetchUserDetailsFailure,
  updateUserDetailsSuccess,
  userLoginSuccess,
  userLoginFailure,
  userRegisterSuccess,
  userRegisterFailure,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  deleteAccountSuccess,
  deleteAccountFailure,
  updateUserDetailsFailure,
  emailVerificationFailure,
  emailVerificationResendFailure,
  emailVerificationSuccess,
  emailVerificationResendSuccess,
  notificationStatusUpdateSuccess,
  notificationStatusUpdateFailure,
  fetchPaymentsSuccess,
  fetchPaymentsFailure,
  saveBlockUserSuccess,
  saveBlockUserFailure,
  fetchBlockUsersSuccess,
  fetchBlockUsersFailure,
  resetPasswordFailure,
  resetPasswordSuccess,
  usernameValidationSuccess,
  usernameValidationFailure,
  updateUserCoverSuccess,
  updateUserCoverFailure,
  updateUserPictureSuccess,
  updateUserPictureFailure,
  fetchUserDevicesSuccess,
  fetchUserDevicesError,
  saveReportUserSuccess,
  saveReportUserFailure,
  verifyEmailSuccess,
  verifyEmailFailed,
  verifyUsernameSuccess,
  verifyUsernameFailed,
  fetchEditProfileSuc,
  fetchEditProfileFailed,
  updateUserNotificationSettingSuccess,
  updateUserNotificationSettingFailure,
  verifyNameSuccess,
  verifyNameFailed,
  googleSignInFailure,
  googleSignInSuccess,
} from "../actions/UserAction";
import {
  LOGIN_START,
  REGISTER_START,
  VERIFY_NAME_START,
  VERIFY_EMAIL_START,
  UPDATE_EMAIL_START,
  GOOGLE_SIGNIN_START,
  FETCH_PAYMENTS_START,
  DELETE_ACCOUNT_START,
  RESET_PASSWORD_START,
  FORGOT_PASSWORD_START,
  VERIFY_USERNAME_START,
  SAVE_BLOCK_USER_START,
  SAVE_REPORT_USER_START,
  FETCH_BLOCK_USERS_START,
  UPDATE_USER_COVER_START,
  EMAIL_VERIFICATION_START,
  FETCH_USER_DETAILS_START,
  FETCH_EDIT_PROFILE_START,
  FETCH_USER_DEVICES_START,
  UPDATE_USER_DETAILS_START,
  UPDATE_USER_PICTURE_START,
  USERNAME_VALIDATION_START,
  USER_ONLINE_STATUS_CHANGED,
  USER_VERIFY_BADGE_STATUS_START,
  EMAIL_VERIFICATION_RESEND_START,
  NOTIFICATION_STATUS_UPDATE_START,
  UPDATE_USER_SECURITY_SETTING_START,
  UPDATE_USER_SOCIAL_MEDIA_SETTING_START,
  UPDATE_USER_NOTIFICATION_SETTING_START,
  UPDATE_USER_PROFILE_VISIBILITY_SETTING_START
} from "../actions/ActionConstant";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../../components/helper/NotificationMessage";
import ErrorUtils from "../../helpers/utils/errors";
import UserStorage from "../../helpers/storage/user";
import { checkLogoutStatus } from "../actions/ErrorAction";
import UserConstantHelpers from "../../helpers/constants/user";
import { update_email_end } from "../../store/actions/UserAction";
import { showUserOTPModal } from "../../store/actions/ModalAction";
import { updatePayoutInfo } from "../../store/actions/PayoutAction";
import { FETCH_CURRENT_USER_START } from "../actions/ActionConstant";
import { fetchCurrentUserFailed } from "../actions/BankAccountAction";
import { fetchCurrentUserSuccess } from "../actions/BankAccountAction";
import { verifyResetTokenFailure } from "../../store/actions/UserAction";
import { verifyResetEmailSuccess } from "../../store/actions/UserAction";
import { verifyResetEmailFailure } from "../../store/actions/UserAction";
import { verifyResetTokenSuccess } from "../../store/actions/UserAction";
import { VERIFY_RESET_EMAIL_START } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_TOKEN_START } from "../../store/actions/ActionConstant";
import { fetchUserConfigurationsStart } from "../actions/UserConfigurationsAction";
import { hideErrorComponent, showErrorComponent } from "../../store/actions/ComponentAction";
import { setChatroomsUserOnlineStatus, setActiveChatroomUserOnlineStatus } from "../actions/ChatAction";
import { fieldsToKeep } from "../../helpers/constants/storage";
import { getTrackingDataForPayload } from "../../helpers/utils/tracking-link";

function* userOnlineStatusChanged(action) {
  yield put(setChatroomsUserOnlineStatus(action.data))
  yield put(setActiveChatroomUserOnlineStatus(action.data))
}

function* getUserDetailsAPI() {
  try {
    const response = yield api.postMethod("profile");
    if (response.data.success) {
      yield put(fetchUserDetailsSuccess(response.data));
      UserStorage.updateUser(_.pick(response.data, fieldsToKeep));
    yield put(hideErrorComponent());
    } else {
      yield put(fetchUserDetailsFailure(response.data.error));
      yield put(checkLogoutStatus(response.data));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchUserDetailsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserDetailsAPI() {
  try {
    const userData = yield select((state) => state.users.profileInputData.data);
    const response = yield api.postMethod("update_profile", userData);
    const countries = yield select(
      (state) => state.countryModel.countries.data
    );
    if (response.data.success) {
      if(response.data.code == 201){
        api.postMethod("logout")
        window.location.assign(`/verify?email=${response.data.data.email}`);
        return
      }
      yield put(updateUserDetailsSuccess(response.data));
      UserStorage.updateUser(_.pick(response.data.data, fieldsToKeep));

      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );

      if (countries && countries.length) {
        const profileCountry = countries.find(
          (c) => c.id === userData?.country_id
        );
        yield put(
          updatePayoutInfo({
            destinationCountry: profileCountry?.code_3 ?? "USA",
          })
        );
      }

      yield put(createNotification(notificationMessage));
      // Redirect with refresh to repopulate all states to reflect latest changes
      window.location.assign("/profile");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(updateUserDetailsFailure(response.data.error));
    }
  } catch (error) {
    yield put(updateUserDetailsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserCoverAPI() {
  try {
    const userData = yield select((state) => state.users.profileCoverData.data);
    const response = yield api.postMethod("update_cover", userData);
    if (response.data.success) {
      yield put(updateUserCoverSuccess(response.data));
      UserStorage.updateUser({
        cover: response.data.data.cover,
        picture: response.data.data.picture,
      });
      const notificationMessage = getSuccessNotificationMessage(
        "Cover picture updated!"
      );
      yield put(createNotification(notificationMessage));
      yield push("/edit-profile");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(updateUserCoverFailure(response.data.error));
    }
  } catch (error) {
    yield put(updateUserCoverFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserPictureAPI() {
  try {
    const userData = yield select(
      (state) => state.users.profilePictureData.data
    );
    const response = yield api.postMethod("update_picture", userData);
    if (response.data.success) {
      yield put(updateUserPictureSuccess(response.data));
      UserStorage.updateUser({
        cover: response.data.data.cover,
        picture: response.data.data.picture,
      });
      const notificationMessage = getSuccessNotificationMessage(
        "Profile picture updated!"
      );
      yield put(createNotification(notificationMessage));
      yield push("/edit-profile");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(updateUserPictureFailure(response.data.error));
    }
  } catch (error) {
    yield put(updateUserPictureFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserSecuritySettingsAPI() {
  try {
    const userData = yield select((state) => state.users.profileInputData.data);
    const response = yield api.postMethod("update_general_settings", userData);

    if (response.data.success) {
      yield put(updateUserDetailsSuccess(response.data));
      yield getUserDetailsAPI();
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(updateUserDetailsFailure(response.data.error));
    }
  } catch (error) {
    yield put(updateUserDetailsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserSocialMediaSettingsAPI() {
  try {
    const userData = yield select((state) => state.users.profileInputData.data);
    const response = yield api.postMethod("update_is_social_media_links_visible", userData);

    if (response.data.success) {
      yield put(updateUserDetailsSuccess(response.data));
      yield getUserDetailsAPI();
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(updateUserDetailsFailure(response.data.error));
    }
  } catch (error) {
    yield put(updateUserDetailsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* updateUserNotificationSettingsAPI(action) {
  try {
    const response = yield api.postMethod("update_notification_settings", action.data);
    if (response.data.success) {
      yield put(updateUserDetailsSuccess(response.data));
      yield put(updateUserNotificationSettingSuccess(response.data));
      yield put(createNotification(getSuccessNotificationMessage(response.data.message)));
    } else {
      yield put(updateUserNotificationSettingFailure(response.data.error));
      yield put(createNotification(getErrorNotificationMessage(response.data.error)));
    }
  } catch (error) {
    yield put(updateUserNotificationSettingFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(createNotification(getErrorNotificationMessage(error.response.data.error)));
  }
}

function* updateUserProfileVisibilitySettingAPI(action) {
  try {
    const response = yield api.postMethod('update_profile_visibility', action.data);
    if (response.data.success) {
      yield put(updateUserDetailsSuccess(response.data));
      yield put(createNotification(getSuccessNotificationMessage(response.data.message)));
    } else {
      yield put(createNotification(getErrorNotificationMessage(response.data.error)));
    }
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(createNotification(getErrorNotificationMessage(error.response.data.error)));
  }
}

function* userLoginAPI() {
  try {
    const userData = yield select((state) => state.users.loginInputData.data);
    const trackingData = getTrackingDataForPayload();
    const payloadWithTracking = { ...userData, ...trackingData };

    const response = yield api.postMethod("login", payloadWithTracking);
    yield put(userLoginSuccess(response.data));
    if (response.data.success) {
      if (response?.data?.data?.status === "SEND_OTP_NEXT") {
        yield put(showUserOTPModal(userData));
        return;
      }

      if (response.data.code === 1001) {
        const email = response.data.data.email;
        yield push(`/verify?email=${email}&resend=true`);
        return;
      }

      localStorage.setItem("socket", true);
      localStorage.setItem("userLoginStatus", true);
      localStorage.setItem("userId", response.data.data.user_id);
      localStorage.setItem("jwtToken", response.data.data._token);

      UserStorage.updateUser(_.pick(response.data.data, fieldsToKeep));    

      if (
        UserConstantHelpers.isPerformer(response.data.data) &&
        UserConstantHelpers.isDocumentNone(response.data.data)
      ) {
        yield push(`/become-performer`);
      } else {
        yield push("/home");
      }
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(userLoginFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* googleSignInAPI() {
  try {
    const inputData = yield select((state) => state.users.googleSignInData.inputData);
    const trackingData = getTrackingDataForPayload();
    const payloadWithTracking = { ...inputData, ...trackingData };

    const response = yield api.postMethod("google_login", payloadWithTracking);

    if (response.data.success) {
      yield put(googleSignInSuccess(response.data.data))

      if (response.data.code === 196) {
        // redirect to sign up
        yield put(createNotification(getErrorNotificationMessage('We did not find your account, please fill out the registration form.')));
        yield push(`/register`);        
        return;
      } else {
        yield put(userLoginSuccess(response.data));

        if (response.data.code === 1001) {
          const email = response.data.data.email;
          yield push(`/verify?email=${email}&resend=true`);
          return;
        } else {
          // user should login
          localStorage.setItem("socket", true);
          localStorage.setItem("userLoginStatus", true);
          localStorage.setItem("userId", response.data.data.user_id);
          localStorage.setItem("jwtToken", response.data.data._token);

          UserStorage.updateUser(_.pick(response.data.data, fieldsToKeep));

          if (
            UserConstantHelpers.isPerformer(response.data.data) &&
            UserConstantHelpers.isDocumentNone(response.data.data)
          ) {
            yield push(`/become-performer`);
          } else {
            yield push("/home");
          }
        }
      }
    } else {
      yield put(googleSignInFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }

  } catch (error) {
    yield put(googleSignInFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export function* userRegisterAPI() {
  try {
    const userData = yield select(
      (state) => state.users.registerInputData.data
    );
    const trackingData = getTrackingDataForPayload();
    const payloadWithTracking = { ...userData, ...trackingData };
    const response = yield api.postMethod("register", payloadWithTracking);
    yield put(userRegisterSuccess(response.data));

    if (response.data.success) {
      const successMessage = yield getSuccessNotificationMessage(
        response.data.message
      );

      yield put(createNotification(successMessage));
      if (!response.data.data.is_email_verified) {
        yield push(`/verify?email=${response.data.data.email}`);
      } else {
        localStorage.setItem("socket", true);
        localStorage.setItem("userLoginStatus", true);
        localStorage.setItem("userId", response.data.data.user_id);
        localStorage.setItem("jwtToken", response.data.data._token);

        UserStorage.updateUser(_.pick(response.data.data, fieldsToKeep));

        yield push("/home");
      }
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(userRegisterFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* forgotPasswordAPI() {
  try {
    const userData = yield select(
      (state) => state.users.forgotPasswordInputData.data
    );

    if (
      !userData.email ||
      userData.email === undefined ||
      userData.email == null
    ) {
      const notificationMessage = getErrorNotificationMessage(
        "Please enter the email address"
      );
      yield put(createNotification(notificationMessage));
    } else {
      const response = yield api.postMethod("forgot_password", userData);
      yield put(forgotPasswordSuccess(response.data));
      if (response.data.success) {
        const notificationMessage = getSuccessNotificationMessage(
          response.data.message
        );
        yield put(createNotification(notificationMessage));
        yield push("/login");
      } else {
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    yield put(forgotPasswordFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* deleteAccountAPI() {
  try {
    const userData = yield select(
      (state) => state.users.deleteAccount.inputData
    );
    const response = yield api.postMethod("delete_account", userData);
    yield put(deleteAccountSuccess(response.data));
    if (response.data.success) {
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      localStorage.clear();
      yield push("/login");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* emailVerification() {
  try {
    const inputData = yield select(
      (state) => state.users.emailVerification.inputData
    );

    const response = yield api.postMethod("verify_email", inputData);
    if (response.data.success) {
      yield put(emailVerificationSuccess(response.data));
    } else {
      yield put(emailVerificationFailure(response.data.error));
    }
  } catch (error) {
    yield put(emailVerificationFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* emailVerificationResend() {
  try {
    const inputData = yield select(
      (state) => state.users.emailVerificationResend.inputData
    );
    const response = yield api.postMethod(
      "resend_email_verification",
      inputData
    );

    if (response.data.success) {
      yield put(emailVerificationResendSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        "Verification code has been sent"
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(emailVerificationResendFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      if (response.data.error_code === 205) {
        yield put(emailVerificationResendFailure(response.data.error));
        const notificationMessage = getSuccessNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
        yield push("/login");
        return;
      }
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(emailVerificationResendFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* notificationStatusUpdateAPI() {
  try {
    const userData = yield select(
      (state) => state.users.notificationUpdate.inputData
    );
    const response = yield api.postMethod(
      "notifications_status_update",
      userData
    );
    if (response.data.success) {
      yield put(notificationStatusUpdateSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(notificationStatusUpdateFailure(response.data.error));
    }
  } catch (error) {
    yield put(notificationStatusUpdateFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* verificationBadgeStatusUpdateAPI() {
  try {
    const userData = yield select(
      (state) => state.users.verifyBadgeUpdate.inputData
    );
    const response = yield api.postMethod("verified_badge_status", userData);
    if (response.data.success) {
      yield put(notificationStatusUpdateSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      UserStorage.updateUser({
        is_verified_badge: response.data.data.is_verified_badge
          ? response.data.data.is_verified_badge
          : 0,
      });
      yield put(createNotification(notificationMessage));
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(notificationStatusUpdateFailure(response.data.error));
    }
  } catch (error) {
    yield put(notificationStatusUpdateFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* getPaymentsAPI() {
  try {
    const response = yield api.postMethod("payments_index");

    if (response.data.success) {
      yield put(fetchPaymentsSuccess(response.data));
    } else {
      yield put(fetchPaymentsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchPaymentsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error
    );
    yield put(createNotification(notificationMessage));
  }
}

function* fetchBlockUsersAPI() {
  try {
    const response = yield api.postMethod("block_users");
    if (response.data.success) {
      yield put(fetchBlockUsersSuccess(response.data.data));
    } else {
      yield put(fetchBlockUsersFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchBlockUsersFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* saveBlockUserAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.saveBlockUser.inputData
    );
    const response = yield api.postMethod("block_users_save", inputData);
    if (response.data.success) {
      yield put(saveBlockUserSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      if (inputData.is_other_profile == 1) {
        window.location.reload();
      }
    } else {
      yield put(saveBlockUserFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(saveBlockUserFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* resetPasswordAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.resetPassword.inputData
    );
    const response = yield api.postMethod("reset_password", inputData);
    yield put(resetPasswordSuccess(response.data));
    if (response.data.success) {
      yield put(resetPasswordSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield push("/login");
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(resetPasswordFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* usernameValidationAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.validationInputData.data
    );
    const response = yield api.postMethod("username_validation", inputData);
    yield put(usernameValidationSuccess(response.data));
    if (response.data.success) {
    } else {
      yield put(usernameValidationFailure(response));
    }
  } catch (error) {
    yield put(usernameValidationFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetcUserDevicesAPI() {
  try {
    const inputData = yield select((state) => state.users.search.inputData);
    const response = yield api.postMethod("device_list", inputData);
    if (response.data.success) {
      yield put(fetchUserDevicesSuccess(response.data.data));
    } else {
      yield put(fetchUserDevicesError(response.data.error));
      yield put(
        createNotification(getErrorNotificationMessage(response.data.error))
      );
    }
  } catch (error) {
    yield put(fetchUserDevicesError(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

//fetchCurrentUser

function* fetchCurrentUserAPI() {
  try {
    yield put(fetchUserConfigurationsStart());
    yield delay(500);
    const response = yield api.postMethod("profile");
    if (response.data.success) {
      yield put(fetchCurrentUserSuccess(response.data.data));
    } else {
      yield put(fetchCurrentUserFailed(response.data.error));
    }
  } catch (error) {
    yield put(fetchCurrentUserFailed(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

//verifyResetEmail

function* verifyResetEmailAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.verifyResetEmail.inputData
    );
    const response = yield api.postMethod("forgot_password", inputData);
    if (response.data.success) {
      yield put(verifyResetEmailSuccess(response.data.success));
    } else {
      if (response.data.error_code === 118) {
        return yield put(
          verifyResetEmailFailure({
            message:
              "This email was registered through the Google sign in option, please use the Google 'Forgot Your Password' Process.",
            invalidEmail: false,
            isManualLogin: false,
          })
        );
      }
      return yield put(
        verifyResetEmailFailure({
          message:
            "This account doesn’t seem to be registered, please make sure the email is correct. Please register for an account if email is still not found.",
          invalidEmail: true,
          isManualLogin: true,
        })
      );
    }
  } catch (error) {
    yield put(
      verifyResetEmailFailure({
        message: "Network Error, Please review your internet connection.",
        invalidEmail: false,
        isManualLogin: true,
      })
    );
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

//verifyResetToken

function* verifyResetTokenAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.verifyResetToken.inputData
    );
    const response = yield api.postMethod(
      "verify_reset_password_token",
      inputData
    );
    if (response.data.success) {
      yield put(verifyResetTokenSuccess(response.data.data));
    } else {
      yield put(
        verifyResetTokenFailure({
          type: "api",
          error: response.data.error,
        })
      );
    }
  } catch (error) {
    yield put(
      verifyResetTokenFailure({
        type: "network",
        token_expired: false,
        error: error,
      })
    );
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* saveReportUserAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.saveReportUser.inputData
    );
    const response = yield api.postMethod("report_users_save", inputData);
    if (response.data.success) {
      yield put(saveReportUserSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(saveReportUserFailure(response.data.error));
      const { notify, message } = ErrorUtils.handleApiError(response.data)
      if (notify) {
        yield put(createNotification(getErrorNotificationMessage(message)));
      }
    }
  } catch (error) {
    yield put(saveReportUserFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* verifyEmailAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.verifyEmail.inputData
    );
    const response = yield api.postMethod("email_validation", inputData);
    if (response.data.success) {
      yield put(verifyEmailSuccess(response.data));
    } else {
      yield put(verifyEmailFailed(response.data.error));
    }
  } catch (error) {
    yield put(verifyEmailFailed(error.response));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}
function* verifyUsernameAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.verifyUsername.inputData
    );
    const response = yield api.postMethod("username_validation", inputData);
    if (response.data.success) {
      yield put(verifyUsernameSuccess(response.data));
    } else {
      yield put(verifyUsernameFailed(response.data.error));
    }
  } catch (error) {
    yield put(verifyUsernameFailed(error.response));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* verifyNameAPI() {
  try {
    const inputData = yield select(
      (state) => state.users.verifyName.inputData
    );
    const response = yield api.postMethod("name_validation", inputData);
    if (response.data.success) {
      yield put(verifyNameSuccess(response.data));
    } else {
      yield put(verifyNameFailed(response.data.error));
    }
  } catch (error) {
    yield put(verifyNameFailed(error.response));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* fetchEditProfileAPI() {
  try {
    const response = yield api.postMethod("profile");
    if (response.data.success) {
      yield put(fetchEditProfileSuc(response.data.data));
    } else {
      yield put(fetchEditProfileFailed(response.data.error));
    }
  } catch (error) {
    yield put(fetchEditProfileFailed(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

function* update_email() {
  try {
    const userData = yield select((state) => state.users.updateEmail);

    const response = yield api.postMethod("update_email", userData);
    yield put(userLoginSuccess(response.data));
      if (response.data.success) {
      const successMessage = yield getSuccessNotificationMessage(
        response.data.message
      );
         yield put(createNotification(successMessage));
         yield put(update_email_end())
        yield push(`/verify?email=${response.data.data.email}`);
        return;
    } else {
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    const notificationMessage = getErrorNotificationMessage(error.message);
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(createNotification(notificationMessage));
  }
}
export { userLoginAPI };

export default function* pageSaga() {
  yield all([
    yield takeLatest(LOGIN_START, userLoginAPI),
    yield takeLatest(GOOGLE_SIGNIN_START, googleSignInAPI),
    yield takeLatest(REGISTER_START, userRegisterAPI),
    yield takeLatest(FETCH_PAYMENTS_START, getPaymentsAPI),
    yield takeLatest(DELETE_ACCOUNT_START, deleteAccountAPI),
    yield takeLatest(RESET_PASSWORD_START, resetPasswordAPI),
    yield takeLatest(SAVE_BLOCK_USER_START, saveBlockUserAPI),
    yield takeLatest(FORGOT_PASSWORD_START, forgotPasswordAPI),
    yield takeLatest(EMAIL_VERIFICATION_START, emailVerification),
    yield takeLatest(FETCH_USER_DETAILS_START, getUserDetailsAPI),
    yield takeLatest(UPDATE_USER_COVER_START, updateUserCoverAPI),
    yield takeLatest(FETCH_BLOCK_USERS_START, fetchBlockUsersAPI),
    yield takeLatest(FETCH_USER_DEVICES_START, fetcUserDevicesAPI),
    yield takeLatest(UPDATE_USER_DETAILS_START, updateUserDetailsAPI),
    yield takeLatest(UPDATE_USER_PICTURE_START, updateUserPictureAPI),
    yield takeLatest(USERNAME_VALIDATION_START, usernameValidationAPI),
    yield takeLatest(USER_ONLINE_STATUS_CHANGED, userOnlineStatusChanged),
    yield takeLatest(EMAIL_VERIFICATION_RESEND_START, emailVerificationResend),
    yield takeLatest(UPDATE_EMAIL_START, update_email),
    yield takeLatest(
      NOTIFICATION_STATUS_UPDATE_START,
      notificationStatusUpdateAPI
    ),
    yield takeLatest(
      USER_VERIFY_BADGE_STATUS_START,
      verificationBadgeStatusUpdateAPI
    ),
    yield takeLatest(
      UPDATE_USER_SECURITY_SETTING_START,
      updateUserSecuritySettingsAPI
    ),
    yield takeLatest(
      UPDATE_USER_SOCIAL_MEDIA_SETTING_START,
      updateUserSocialMediaSettingsAPI
    ),
    yield takeLatest(
      UPDATE_USER_NOTIFICATION_SETTING_START,
      updateUserNotificationSettingsAPI
    ),
    yield takeLatest(
      UPDATE_USER_PROFILE_VISIBILITY_SETTING_START,
      updateUserProfileVisibilitySettingAPI
    ),
    yield takeLatest(FETCH_CURRENT_USER_START, fetchCurrentUserAPI),
    yield takeLatest(VERIFY_RESET_EMAIL_START, verifyResetEmailAPI),
    yield takeLatest(VERIFY_RESET_TOKEN_START, verifyResetTokenAPI),
    yield takeLatest(SAVE_REPORT_USER_START, saveReportUserAPI),
    yield takeLatest(VERIFY_EMAIL_START, verifyEmailAPI),
    yield takeLatest(VERIFY_USERNAME_START, verifyUsernameAPI),
    yield takeLatest(FETCH_EDIT_PROFILE_START, fetchEditProfileAPI),
    yield takeLatest(VERIFY_NAME_START, verifyNameAPI),
  ]);
}
